export function calculatePercentage(amount, percentage) {
  const parsedAmount = parseFloat(amount);
  const parsedPercentage = parseFloat(percentage);

  // console.log("parsedPercentage",parsedPercentage)

  if (parsedPercentage === 0) {
    return amount;
  }

  if (isNaN(parsedAmount) || isNaN(parsedPercentage)) {
    return "Invalid values";
  }

  const result = parsedAmount - parsedAmount * (parsedPercentage / 100);

  return result;
}
